import { HttpHeaders } from '@angular/common/http';

export const URL_SERVICIOS = 'https://wssigec.comfamiliar.com/webresources/alojamiento/';
// export const URL_SERVICIOS = 'http://localhost:8080/rolcliente/webresources/alojamiento/';

// export const URL_SERVICIOS = 'https://wssigec.comfamiliar.com/webresources/alojamiento/';

export const URL_SERVICIOS_CONSOTA = 'https://wssigec.comfamiliar.com/webresources/consota/';
export const URL_SIGEC = 'https://wssigec.comfamiliar.com/webresources/sigec/';

export const HTTPOPTIONS = {
    headers: new HttpHeaders({
      // 'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8',
      'Content-Type' : 'application/json',
      'Authorization': 'my-new-auth-token'
    })
  };

export const ERROR_CONSULTANDOSERVICIO: String = 'Error consultando el servicio';

export const COLOR_INFO = 'info';
export const COLOR_SUCCESS = 'success';
export const COLOR_WARNING = 'warning';
export const COLOR_DANGER = 'danger';
export const COLOR_ROSE = 'rose';
export const COLOR_PRIMARY = 'primary';

